import { render, staticRenderFns } from "./RunnitBatchProcessingProgressCard.vue?vue&type=template&id=22ade657"
import script from "./RunnitBatchProcessingProgressCard.vue?vue&type=script&lang=ts"
export * from "./RunnitBatchProcessingProgressCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports